import api from './api';

class NewsService {
  async getPharmaceuticalNews(limit = 10) {
    try {
      const response = await api.get(`/news/pharmaceutical?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching pharmaceutical news:', error);
      throw error;
    }
  }

  async getHealthNews(limit = 10) {
    try {
      const response = await api.get(`/news/health?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching health news:', error);
      throw error;
    }
  }

  async getCombinedNews(limit = 8) {
    try {
      const response = await api.get(`/news/combined?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching combined news:', error);
      throw error;
    }
  }
}

const newsService = new NewsService();

export default newsService;